import axios from 'axios';
import WebApi from '../WebApi';
class AutocompleteWebApi extends WebApi {
    async getAddresses(address) {
        const { data } = await axios.post(`${this.urlPrefix}/ac_addresses`, { address });
        return data.addresses;
    }
    async getFrAddresses(address) {
        const { data } = await axios.post(`${this.urlPrefix}/ac_fr_addresses`, { address });
        return data.addresses;
    }
    async fetchPlaceById(place) {
        const { data } = await axios.post(`${this.urlPrefix}/ac_addresses/fetch`, { place });
        return data.place;
    }
}
const autocompleteWebApi = new AutocompleteWebApi();
export { autocompleteWebApi as AutocompleteWebApi, };
